import { Inventory } from "@DataPages/types/inventory/models/inventory.ts";
import { GridStatePremium } from "@mui/x-data-grid-premium/models/gridStatePremium";

export function extractFilteredRows(
	state: GridStatePremium,
	from: "isVehicleDetailedInformationDialogOpen" | "isGPSInformationDialogOpen"
) {
	const { sorting, visibleRowsLookup, rows } = state;
	return sorting.sortedRows
		.filter(
			(key) =>
				visibleRowsLookup[key] &&
				(from === "isVehicleDetailedInformationDialogOpen"
					? rows.dataRowIdToModelLookup[key].dmsId
					: rows.dataRowIdToModelLookup[key].gpsId && rows.dataRowIdToModelLookup[key].gpsProtected)
		)
		.map((key) => rows.dataRowIdToModelLookup[key] as Inventory);
}

export function getIsButtonDisabled(button: "prev" | "next", rows: Inventory[], vin: string) {
	if (vin) {
		const selectedVehicleIndex = rows.findIndex((vehicle) => vehicle.vin === vin);
		if (button === "prev") {
			return selectedVehicleIndex === 0;
		} else if (button === "next") {
			return selectedVehicleIndex === rows.length - 1;
		}
	}

	return true;
}

export const getTransformedVehicleDetails = (obj: object) => {
	if (!obj) {
		return [];
	}
	const objKeys: Array<keyof typeof obj> = Object.keys(obj) as Array<keyof typeof obj>;

	return objKeys.map((key) => {
		return getTransformedObject(obj[key]);
	});
};

function getTransformedObject<T extends object>(obj: T): { label: string; _id: string }[] {
	return Object.keys(obj).map((currentKey) => {
		// Correctly type currentKey as keyof T
		const key = currentKey as keyof T;
		if (typeof obj[key] === "object" && obj[key] !== null && "isSubheader" in obj[key]) {
			return { label: `${String(key)}`, _id: currentKey, isSubheader: true };
		}
		return { label: `${String(key)}: ${obj[key]}`, _id: currentKey, isSubheader: false };
	});
}
